export default {"src":"/_next/static/media/FilterDDIcon.97ebe821.svg","height":20,"width":23,"blurWidth":0,"blurHeight":0};